import { CpLobby } from '@/components/chinesepoker/CpLobby';

/**
 * QChinesePoker lobby route. The actual content lives in <CpLobby /> so the
 * Hub's Gioca panel (QcpPlayPanel) can render the same controls; this route
 * stays alive for deep-links and the result screen's "Play again".
 */
export function ChinesePokerHome() {
  return <CpLobby />;
}
